import React from 'react';
import { Component as ComponentContainer } from '@styles/layout';
import { SectionTitle, SectionTitleSizes } from '@components/common/section-title';
import { TextMarkdown } from '@components/common/description';
import { TestId } from '@components/test-ids';
import { useI18NextContext } from '@components/hooks';

export const DiscoverTheWorld = () => {
  const t = useI18NextContext();
  return (
    <ComponentContainer data-testid={TestId.discover.main}>
      <SectionTitle size={SectionTitleSizes.LARGE} heading={t('discover-the-world__title')} />
      <TextMarkdown description={t('discover-the-world__description')} />
    </ComponentContainer>
  );
};
